import { Select } from './ui/Select';
import { useI18n, localeMeta, locales } from '../i18n/provider';

interface LocaleSwitcherProps {
  compact?: boolean;
  className?: string;
}

export function LocaleSwitcher({ compact = false, className = '' }: LocaleSwitcherProps): JSX.Element {
  const { locale, setLocale, t } = useI18n();

  return (
    <div className={className}>
      <label htmlFor="admin-locale" className="sr-only">
        {t('common.language')}
      </label>
      <Select
        id="admin-locale"
        value={locale}
        onChange={(event) => setLocale(event.target.value as (typeof locales)[number])}
        className={compact ? 'h-8 min-w-[90px] text-xs pl-2 pr-7 py-1' : 'h-10 min-w-[120px] text-sm'}
      >
        {locales.map((code) => (
          <option key={code} value={code}>
            {localeMeta[code].flag} {code.toUpperCase()}
          </option>
        ))}
      </Select>
    </div>
  );
}
